export default {
      id: "arrows-bended-usage",
      viewBox: "0 0 198 219",
      url: __webpack_public_path__ + "svg/sprite.svg#arrows-bended",
      toString: function () {
        return this.url;
      }
    }